import Layout from '@/layout'

const stockRouter = {
  path: "/stock/query",
  redirect:'/stock/query',
  name:'stockIndex',
  hiddeChilden:true,
  meta: { 
    title: 'menu.stock', 
    iconClass: 'el-icon-collection', 
    module:'stock', 
    roles:['EMPLOYEE','SALESMAN','CEO', 'INVENTORY_OBSERVER']
  },
  component: Layout,
  children:[
    {
      path: "/stock/query",
      name: "stockQuery",
      hidden:false,
      component: () => import( "@/views/stock"),
      meta: { 
        title: 'menu.stock', 
        iconClass: 'el-icon-receiving', 
        module:'stock', 
        roles:['EMPLOYEE','SALESMAN','CEO', 'INVENTORY_OBSERVER']
      }
    },
  ]
}

export default stockRouter